import { Edition } from "@carnegie-learning/cure-types";
import { FeathersServicePagination } from "@carnegie-learning/data-access-core";
import { createAction, props } from "@ngrx/store";

export const LOAD_STUDENT_ACTIVEEDITIONS =
    "[Student Courses] Load Active Editions";
export const LOAD_STUDENT_ACTIVEEDITIONS_FAIL =
    "[Student Courses] Load Active Editions Fail";
export const LOAD_STUDENT_ACTIVEEDITIONS_SUCCESS =
    "[Student Courses] Load Active Editions Success";

export const LoadStudentActiveEditions = createAction(
    LOAD_STUDENT_ACTIVEEDITIONS
);

export const LoadStudentActiveEditionsFail = createAction(
    LOAD_STUDENT_ACTIVEEDITIONS_FAIL,
    props<{
        payload: any;
    }>()
);

export const LoadStudentActiveEditionsSuccess = createAction(
    LOAD_STUDENT_ACTIVEEDITIONS_SUCCESS,
    props<{
        payload: FeathersServicePagination<Edition>;
    }>()
);
